import React from "react";

export default function SortBy(props: any) {
  return (
    <svg
    width={16}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#fff" d="M0 .5h16v16H0z" />
    <path
      d="M7.997 13.168h6.667M4.664 8.5h10M1.33 3.834h13.334"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  );
}